<template>
  <div class="home-module">
    <div class="module-title fc">
      <div>
        <img src="../../../assets/icons/ico_home_title_left.svg" />
        <img src="../../../assets/icons/ico_home_title_left.svg" />
      </div>
      <span>{{ props.title }}</span>
      <div>
        <img src="../../../assets/icons/ico_home_title_right.svg" />
        <img src="../../../assets/icons/ico_home_title_right.svg" />
      </div>
    </div>
    <div class="module-content">
      <slot/>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
});
</script>

<style lang="less" scoped>
.home-module {
  margin-top: 80px;
  .module-title {
    color: #151E2C;
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;
    margin-bottom: 30px;
    span {
      padding: 0 4px;
    }
  }
}
</style>